import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { branchFormItem } from '../examples';
import { condiyionRules } from '../rules';
import CommonHeader from '../components/common-header';
import { getConditionList as _getConditionList } from 'api/flow';
import depart from '../components/depart';
import './directive';
export default {
  components: {
    CommonHeader: CommonHeader,
    depart: depart
  },
  props: {
    // 组件是否展示
    drawer: {
      default: false,
      type: Boolean
    },
    // 当前节点数据
    nodeData: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    baseInfo: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      form: {},
      condiyionRules: condiyionRules,
      // 表单校验规则
      enums: {
        condition: [],
        operator: [],
        option: []
      }
    };
  },
  created: function created() {
    // 数据拷贝
    this.form = _objectSpread(_objectSpread({}, this.form), JSON.parse(JSON.stringify(this.nodeData)));
    this.getConditionList();
  },
  methods: {
    hChange: function hChange(v) {
      console.log(v);
    },
    // 获取全部条件
    getConditionList: function getConditionList() {
      var _this = this;
      _getConditionList({
        audit_type: this.baseInfo.audit_type
      }).then(function (res) {
        if (res && res.code === 1) {
          _this.enums = res.data;
        }
      });
    },
    // 节点条件变化则清空运算符
    // @parms { Object } item 当前条件
    handlerConChange: function handlerConChange(item) {
      item.operator = '';
      item.value = {
        value: ''
      };
    },
    // 组件关闭操作
    handleClose: function handleClose() {
      this.$emit('update:drawer', false);
    },
    // 添加条件
    handlerAddCondition: function handlerAddCondition(traget) {
      traget.push(branchFormItem());
    },
    // 添加条件组
    handlerAddContitionGroup: function handlerAddContitionGroup() {
      this.form.form.push([branchFormItem()]);
    },
    /**
     *  @description 删除条件组
     *  @param { Array } conditions 要删除子项的数组
     *  @param { number } index 要删除对象的下标
     */
    handleDelCondition: function handleDelCondition(group, i) {
      group.splice(i, 1);
    },
    // 删除条件组 index下标
    handlerDelConditonGroup: function handlerDelConditonGroup(index) {
      this.form.form.splice(index, 1);
    },
    /**
     *  @description 表单校验
     *  @returns { Boolean } 校验结果
     */
    branchsValidate: function branchsValidate() {
      return this.$refs.branchs.every(function (item) {
        var result = true;
        item.validate(function (valid) {
          if (!valid) result = false;
        });
        return result;
      });
    },
    // 保存
    handlerSave: function handlerSave() {
      // 自组件校验
      var state = this.branchsValidate();
      // 所有表单校验通过状态
      if (state) {
        var result = _objectSpread(_objectSpread({}, this.nodeData), this.form);
        this.$emit('change', result);
        this.handleClose();
      }
    }
  }
};